import React from 'react';
import { IconProps } from '../types/types';

const MSFT: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#F0F3FA" d="M0 0h18v18H0z"/><path fill="#F0502A" d="M5 5h4v4H5z"/><path fill="#82BA22" d="M9 5h4v4H9z"/><path fill="#FDB92C" d="M9 9h4v4H9z"/><path fill="#1CA7ED" d="M5 9h4v4H5z"/></svg>
);

export default MSFT;